import styled from 'styled-components';
import { isDefined } from 'Utils/type.utils';

interface MarkdownWrapperProps {
  whiteSpace?: 'nowrap';
}

export const MarkdownWrapper = styled.div<MarkdownWrapperProps>`
  & li {
    margin-top: 16px;
  }

  & a {
    color: var(--color-primary);
    white-space: ${({ whiteSpace }) =>
      isDefined(whiteSpace) ? whiteSpace : 'normal'};
    &:hover {
      color: var(--color-secondary);
    }
  }
`;
